// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

// Stable fallback when state is not a Set (e.g. rehydration); avoids a new Set() each selector call.
const EMPTY_SUPPORT_CASES_WITH_UNREAD_MESSAGES = new Set<number>();

export const getSupportCasesWithUnreadMessages = (state: ReduxStateShared): Set<number> => {
  const { supportCasesWithUnreadMessages } = state.messages;
  return supportCasesWithUnreadMessages instanceof Set
    ? supportCasesWithUnreadMessages
    : EMPTY_SUPPORT_CASES_WITH_UNREAD_MESSAGES;
};
